// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!../../../composants/ConsultationBC/ConsultationBC.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles de l'onglet Offre acheteur-BC (V2). Reprend les classes generiques
   partagees (ConsultationBC.css) pour un rendu identique a l'ancienne feuille. */

/* Wrapper principal pour les boutons d'action - alignement à droite */
.action-buttons-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
  padding: 1rem 0;
}

/* Ligne de boutons - alignement horizontal */
.action-buttons-wrapper .action-buttons-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

/* Bouton PDF inline */
.action-buttons-wrapper .print-button-inline {
  display: flex;
  align-items: center;
}

/* Messages de statut dans le wrapper */
.action-buttons-wrapper .status-message {
  margin-left: 0;
}

/* Liste des notifications alignée à droite */
.action-buttons-wrapper .notifications-sent-list {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 0.5rem;
}

/* Styles spécifiques à l'Offre qui complètent ceux de ConsultationBC */
.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  color: #6b7280;
  font-size: 1.1rem;
}

.status-info {
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border-left: 4px solid;
  background-color: rgba(255, 255, 255, 0.1);
}

.no-articles-message {
  text-align: center;
  padding: 3rem;
  color: #6b7280;
  background-color: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.attente-message {
  flex: 1 1;
  margin-left: 2rem;
}

.status-message {
  padding: 1rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  flex: 1 1;
  font-size: 1.1rem;
  margin-left: 2rem;
}

.status-message.accepted {
  background-color: #d1fae5;
  color: #065f46;
  border: 1px solid #10b981;
}

.status-message.refused {
  background-color: #fee2e2;
  color: #991b1b;
  border: 1px solid #ef4444;
}

.status-message.expired {
  background-color: #f3f4f6;
  color: #6b7280;
  border: 1px solid #9ca3af;
}

/* Section Bon de Commande */
.bon-commande-section {
  margin-top: 2rem;
  border-top: 2px solid #e5e7eb;
  padding-top: 2rem;
}

.bon-commande-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px;
  background-color: rgba(218, 112, 39, 0.15);
  border-left: 4px solid #f97316;
  border-radius: 8px;
  margin: 16px 0;
}

.bon-commande-message h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
}

.bon-commande-message p {
  margin: 0 0 12px 0;
  line-height: 1.5;
}

.acceptation-details {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 1rem;
  border-radius: 6px;
  border-left: 4px solid #0ea5e9;
}

.acceptation-details p {
  margin-bottom: 0.5rem;
  color: #0c4a6e;
  font-size: 0.95rem;
}

.acceptation-details p:last-child {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 1rem;
}

.bon-commande-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bon-commande-actions button {
  min-width: 250px;
}

.bon-commande-section svg path {
  fill: white;
}

@keyframes slideInFromTop {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .action-buttons-wrapper {
    flex-direction: column;
    align-items: stretch;
  }

  .action-buttons-wrapper .action-buttons-row {
    flex-direction: column;
    width: 100%;
  }

  .action-buttons-wrapper .action-buttons-row button {
    width: 100%;
  }

  .action-buttons-wrapper .print-button-inline {
    justify-content: center;
    width: 100%;
  }

  .action-buttons-wrapper .notifications-sent-list {
    align-items: center;
  }

  .attente-message {
    margin-left: 0;
    margin-top: 1rem;
  }

  .status-message {
    margin-left: 0;
    margin-top: 1rem;
  }

  .bon-commande-info {
    padding: 1.5rem;
    gap: 1rem;
  }

  .acceptation-details {
    padding: 0.75rem;
  }

  .bon-commande-actions button {
    min-width: auto;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviOperationBCIV2/components/OperationOffre.css"],"names":[],"mappings":"AAAA;iFACiF;;AAIjF,sEAAsE;AACtE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":["/* Styles de l'onglet Offre acheteur-BC (V2). Reprend les classes generiques\n   partagees (ConsultationBC.css) pour un rendu identique a l'ancienne feuille. */\n\n@import \"../../../composants/ConsultationBC/ConsultationBC.css\";\n\n/* Wrapper principal pour les boutons d'action - alignement à droite */\n.action-buttons-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  padding: 1rem 0;\n}\n\n/* Ligne de boutons - alignement horizontal */\n.action-buttons-wrapper .action-buttons-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Bouton PDF inline */\n.action-buttons-wrapper .print-button-inline {\n  display: flex;\n  align-items: center;\n}\n\n/* Messages de statut dans le wrapper */\n.action-buttons-wrapper .status-message {\n  margin-left: 0;\n}\n\n/* Liste des notifications alignée à droite */\n.action-buttons-wrapper .notifications-sent-list {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  margin-top: 0.5rem;\n}\n\n/* Styles spécifiques à l'Offre qui complètent ceux de ConsultationBC */\n.loading-indicator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 3rem;\n  color: #6b7280;\n  font-size: 1.1rem;\n}\n\n.status-info {\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  border-left: 4px solid;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.no-articles-message {\n  text-align: center;\n  padding: 3rem;\n  color: #6b7280;\n  background-color: #f9fafb;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.attente-message {\n  flex: 1;\n  margin-left: 2rem;\n}\n\n.status-message {\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  text-align: center;\n  flex: 1;\n  font-size: 1.1rem;\n  margin-left: 2rem;\n}\n\n.status-message.accepted {\n  background-color: #d1fae5;\n  color: #065f46;\n  border: 1px solid #10b981;\n}\n\n.status-message.refused {\n  background-color: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #ef4444;\n}\n\n.status-message.expired {\n  background-color: #f3f4f6;\n  color: #6b7280;\n  border: 1px solid #9ca3af;\n}\n\n/* Section Bon de Commande */\n.bon-commande-section {\n  margin-top: 2rem;\n  border-top: 2px solid #e5e7eb;\n  padding-top: 2rem;\n}\n\n.bon-commande-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 20px;\n  background-color: rgba(218, 112, 39, 0.15);\n  border-left: 4px solid #f97316;\n  border-radius: 8px;\n  margin: 16px 0;\n}\n\n.bon-commande-message h4 {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.bon-commande-message p {\n  margin: 0 0 12px 0;\n  line-height: 1.5;\n}\n\n.acceptation-details {\n  background-color: rgba(255, 255, 255, 0.7);\n  padding: 1rem;\n  border-radius: 6px;\n  border-left: 4px solid #0ea5e9;\n}\n\n.acceptation-details p {\n  margin-bottom: 0.5rem;\n  color: #0c4a6e;\n  font-size: 0.95rem;\n}\n\n.acceptation-details p:last-child {\n  margin-bottom: 0;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.bon-commande-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.bon-commande-actions button {\n  min-width: 250px;\n}\n\n.bon-commande-section svg path {\n  fill: white;\n}\n\n@keyframes slideInFromTop {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .action-buttons-wrapper {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .action-buttons-wrapper .action-buttons-row {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .action-buttons-wrapper .action-buttons-row button {\n    width: 100%;\n  }\n\n  .action-buttons-wrapper .print-button-inline {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .action-buttons-wrapper .notifications-sent-list {\n    align-items: center;\n  }\n\n  .attente-message {\n    margin-left: 0;\n    margin-top: 1rem;\n  }\n\n  .status-message {\n    margin-left: 0;\n    margin-top: 1rem;\n  }\n\n  .bon-commande-info {\n    padding: 1.5rem;\n    gap: 1rem;\n  }\n\n  .acceptation-details {\n    padding: 0.75rem;\n  }\n\n  .bon-commande-actions button {\n    min-width: auto;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
